import store from './../store/';
import api from "../api/newget";

// export const auth = (to: any, from: any, next: any) => {
//   const exp = store.state.auth.tokenExp;
//   if (store.state.auth.authToken
//     && (!exp || (exp && Date.now() < (exp * 1000)))) {
//     next();
//   } else {
//     next('/splash');
//   }
// };

export const loggedOut = (to: any, from: any, next: any) => {
  if(to.query.unauthorized === 'true' && to.query.fromSplash === 'true'){
    next()
  }else{
    isAuthenticated()
    .then((isAuthed) => {
      if (isAuthed) {
        next('/');
      } else {
        next();
      }
    })
    .catch((err) => {
      next('/splash');
    });
  }
};

export const hasToHaveCompanies = async (to: any, from: any, next: any) => {
  const companies = await store.dispatch('getCompanies');
  if (companies.entitlements && companies.entitlements.length) {
    next();
  } else {
    next({
      path: '/splash',
      query: {
        fromAuth: 'false',
        fromSplash: 'true',
        requiresAuth: 'false',
        unauthorized: 'true'
      }
    });
  }
};


export const newAuth = async (to: any, from: any, next: any) => {
  console.log("calling user details")
  if (to.meta.fromAuth && to.meta.requiresAuth) {
    try{
      const res = await api.get("/userdetails");
      if (res.data && res.data.email) {
        store.dispatch('onLogin', {
          user: res.data.email || "",
          givenName: res.data.given_name || "",
          familyName: res.data.family_name || "",
          exp: res.data.exp || 0
        });
        next();
      }else{
        next("/splash");
      }      
    }catch(err){
      console.log("In cache")
      next("/splash");
    }    
  } 
  else if (!to.meta.fromAuth && to.meta.fromSplash){
    console.log("In splash from splash");
    next();
  }
  else {
    isAuthenticated()
      .then((isAuthed) => {
        console.log(isAuthed);
        if (isAuthed) {
          next();
        } else {
          console.log("In splash");
          next('/splash');
        }
      })
      .catch((err) => {
        console.error("Error checking authentication", err);
        next('/splash');
      });
  }
};

export const isAuthenticated = async () => {
  try {
    const res = await api.get("/isauth");
    if (res.data && res.data.isAuth) {
      store.commit('setIsAuth', true);
      return true;
    } else {
      store.commit('setIsAuth', false);
      return false;
    }
  } catch (error) {
    store.commit('setIsAuth', false);
    return false;
  }
};

